import { render } from "./ParentEventPlanning.vue?vue&type=template&id=05540d72"
import script from "./ParentEventPlanning.vue?vue&type=script&lang=js"
export * from "./ParentEventPlanning.vue?vue&type=script&lang=js"

import "./ParentEventPlanning.vue?vue&type=style&index=0&id=05540d72&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__